import { render, staticRenderFns } from "./CompanyEmployees.vue?vue&type=template&id=6f0e476a&scoped=true"
import script from "./CompanyEmployees.vue?vue&type=script&lang=js"
export * from "./CompanyEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e476a",
  null
  
)

export default component.exports